<script>
import appConfig from "@/app.config";
import sharedDocumentsApi from "@/services/sharedDocuments-api";
import Swal from "sweetalert2";
import i18n from "../i18n";

export default {
    page: {
        title: "Liste Des Documents",
        meta: [{ name: "description", content: appConfig.description }]
    },

    mounted(){
        if(this.type != null){
            this.getSharedDocumentsByType();
        }

    },
    props: {
        type: {
            type: Number,
            default: -1
        },
        isHomePage: {
            type: Boolean,
            default: false
        },
    },
    
    data() {
        return {
            sharedDocumentbyType: [],
            pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
            isGetSharedDocumentsStarting: false
        }
    }, 

    watch: {
        type: function() {
            this.getSharedDocumentsByType();
        },

    },

    computed: {
        role() {
            return this.$cookies.get('userr'); 
        },

        fields() {
            const baseFields = [
            { key: "documentName", label: "Documents" }
            ];

            if (this.role === 1 && !this.isHomePage) {
               baseFields.push( { key: "timeStamp", label: "Date" });

                baseFields.push({ key: "documentType", label: "Type du Document" });
                baseFields.push({ key: "isActive", label: "Actif" ,thClass: "text-center"});
                baseFields.push({ key: "isSmallAnnouncement", label: "Bande d'annonce" ,thClass: "text-center"});
            }

            baseFields.push({ key: "action", label: "", thClass: "text-right align-middle", tdClass: "text-right align-middle" });

            return baseFields;
        }
        },


    methods:{

        editSharedDocument(item) {
            this.$emit('editSharedDocument', item);
        },


        setIsSmallAnnouncement(item) {
            
            this.isGetSharedDocumentsStarting = true;
            this.sharedDocumentbyType = [];
            sharedDocumentsApi.setIsSmallAnnouncement(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.type, item.id, item.isSmallAnnouncement, item.isActive).then((result) => {
                this.sharedDocumentbyType=result.list ;
                this.pagemodelMain.totalRows = result.total;
                this.pagemodelMain.currentPage = result.page;
                this.pagemodelMain.perPage = result.pageSize;
                this.pagemodelMain.pageSize = result.pageSize;
                this.isGetSharedDocumentsStarting = false;

            }).finally(() => {
                this.isGetSharedDocumentsStarting = false;
            });
        },



        deleteSharedDocument(item) {

            Swal.fire({
                title: i18n.t('sharedDocument.swal.title'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                cancelButtonText: i18n.t('sharedDocument.swal.cancelButtonText'),
                confirmButtonText: i18n.t('sharedDocument.swal.confirmButtonText'),
            }).then((result) => {
                if (result.value) {
                    this.isGetSharedDocumentsStarting = true;
                    this.sharedDocumentbyType = [];
                    sharedDocumentsApi.deleteSharedDocument(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.type, item.id).then((result) => {
                        this.sharedDocumentbyType=result.list ;
                        this.pagemodelMain.totalRows = result.total;
                        this.pagemodelMain.currentPage = result.page;
                        this.pagemodelMain.perPage = result.pageSize;
                        this.pagemodelMain.pageSize = result.pageSize;
                        this.isGetSharedDocumentsStarting = false;

                    }).finally(() => {
                        this.isGetSharedDocumentsStarting = false;
                    });
            }}
        );
        },

        downloadSharedDocument(fileName) {
            sharedDocumentsApi.downloadSharedDocument(fileName)
        },

        getLabelByType(type) {
            switch(type) {
            case 0: return "Packs";
            case 1: return "Catalogues Fournisseurs";
            default: return "-";
            }
        },  

        getSharedDocumentsByType() {
            this.isGetSharedDocumentsStarting = true;
            this.sharedDocumentbyType = [];
            sharedDocumentsApi.getSharedDocumentsByType(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.type).then((result) => {
                this.sharedDocumentbyType=result.list ;
                this.pagemodelMain.totalRows = result.total;
                this.pagemodelMain.currentPage = result.page;
                this.pagemodelMain.perPage = result.pageSize;
                this.pagemodelMain.pageSize = result.pageSize;
                this.isGetSharedDocumentsStarting = false;

            }).finally(() => {
                this.isGetSharedDocumentsStarting = false;
            });
        },

    },
}
</script>
<template>

  <div>

    <div v-if="isHomePage">
        <h2 class="text-primary text-center font-size-16 mb-3">Nos  {{ getLabelByType(this.type) }}</h2>
    </div>

        <div class="table-responsive mt-4 mb-0" style="max-height:31em;min-height:31em">
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="sharedDocumentbyType"
            :fields="fields"
            :perPage="pagemodelMain.perPage"
            :class="{ 'hide-head': isHomePage }">
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>

             <template v-slot:cell(documentName)="{item, value}">
                <div class=" mt-1 mb-1">
                    <div class="text-primary font-weight-bold font-size-14">{{ value }}</div>
                    <i v-if="isHomePage" class=" text-dark" style="font-size:10px;">{{ item.timeStamp }}</i>
                </div>
            </template>

            <template v-slot:cell(documentType)="{value}">
                <span class="text-primary font-weight-bold">{{ getLabelByType(value) }}</span>
            </template>

            <template v-slot:cell(isActive)="{item}">
                 <div class="form-group  text-center m-0" >
                        <b-form-checkbox
                        :value="true"
                        :unchecked-value="false"
                        v-model="item.isActive"
                        class="custom-checkbox custom-checkbox-success mb-0 mt-0"
                        @input="setIsSmallAnnouncement(item)"
                        ></b-form-checkbox>
                    </div>

            </template>

            <template v-slot:cell(isSmallAnnouncement)="{item}">
                 <div class="form-group  text-center m-0" >
                        <b-form-checkbox
                        :value="true"
                        :unchecked-value="false"
                        v-model="item.isSmallAnnouncement"
                        class="custom-checkbox custom-checkbox-success mb-0 mt-0"
                        @input="setIsSmallAnnouncement(item)"
                        ></b-form-checkbox>
                    </div>

            </template>

            <template v-slot:cell(action)="{item}">


                <b-button  title="Ouvrir"  size="sm" @click="downloadSharedDocument(item.fileName)"  variant="outline-dark" >
                            <span class="font-size-12 font-weight-bold" style="cursor: pointer;"><i class=" fas fa-external-link-alt action-icon mr-1" style="cursor: pointer;" ></i> <span >Ouvrir </span></span>
                </b-button> 
               
                <i v-if="!isHomePage" class="fas fa-pencil-alt  ml-2 " style="cursor: pointer;" @click="editSharedDocument(item)" ></i>
                <i v-if="!isHomePage" class="fas fa-trash-alt  ml-2 text-danger " style="cursor: pointer;" @click="deleteSharedDocument(item)"></i>
            </template>
           
            </b-table>
            <span v-if="!isGetSharedDocumentsStarting && !sharedDocumentbyType.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
        </div>
         <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getSharedDocumentsByType()"  v-model="pagemodelMain.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMain.currentPage" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getSharedDocumentsByType()" :disabled="isGetSharedDocumentsStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  --> 

  </div>

</template>

<style scoped>
.hide-head ::v-deep thead {
  display: none;
}
</style>
